import styled from "styled-components";

export const PlayerWrapper = styled.div`
  .cld-video-player.video-js.vjs-fill:not(.vjs-audio-only-mode) {
    width: auto;
  }

  .vjs-menu-content {
    right: 2rem;
  }

  @media (max-width: 475px) {
    .vjs-menu-content {
      max-height: 35vw !important; // overrides the default max-height so that the  playback speed menu can be scrolled on smaller screens
    }
  }

  video.vjs-tech {
    position: initial;
  }
`;
